module.exports = __webpack_public_path__ + "static/img/Madhatter2svg.c514c6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/Madhatter2svg.svg
// module id = xs5A
// module chunks = 1